import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface IPromptPreset {
    id: string;
    title: string;
    prompt: string;
}

export interface IShortcut {
    id: string;
    title: string;
    url: string;
    imageSrc: string;
}

export interface IHomeContent {
    prompts: IPromptPreset[];
    shortcuts: IShortcut[];
}

@Injectable({ providedIn: 'root' })
export class HomeContentService {
    private readonly _http = inject(HttpClient);

    public get(): Observable<IHomeContent> {
        return this._http.get<IHomeContent>('/api/home-content');
    }
}
